import React from 'react';

import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import { HeaderBrandingWrapper, PanelChatHeaderWrapper } from './PanelChatHeader.styled';

const PanelChatHeader: React.FC = () => {
    const { assistantName, brandingText } = useOcFabWidgetOptions();
    
    return (
        <PanelChatHeaderWrapper>
            <h4>{assistantName}</h4>
            <HeaderBrandingWrapper>
                {brandingText}
            </HeaderBrandingWrapper>
        </PanelChatHeaderWrapper>
    );
};

export default PanelChatHeader;
